// extracted by mini-css-extract-plugin
export var button = "_86-7";
export var buttonRow = "_86-6";
export var fadeIn = "_86-1";
export var gradient = "_86-0";
export var panel = "_86-2";
export var panelIn = "_86-3";
export var subtitle = "_86-5";
export var title = "_86-4";